import AdminBoard from '../components/features/admin/AdminBoard';

/**
 * AdminPage component
 * Admin dashboard for property management
 */
const AdminPage: React.FC = () => {
  return <AdminBoard />;
};

export default AdminPage;
